<template>
  <div class="register-container">
    <!-- 顶部 -->
    <div class="header">
      <div class="logo-section">
        <img src="@/assets/logo_black.png" alt="logo" class="logo" />
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 顶部Tab -->
      <div class="tab-section">
        <div class="tab-item active">企业用户</div>
        <div class="login-link">
          <span>我已经注册</span>
          <a @click="goLogin">登录</a>
        </div>
      </div>

      <!-- 表单内容 -->
      <div class="form-section">
        <Form ref="registerForm" :model="formData" :rules="rules" :label-width="105" label-position="right">
          <!-- 账户信息 -->
          <div class="section-title">账户信息</div>
          <FormItem label="用户名：" prop="userName">
            <Input v-model="formData.userName" placeholder="" style="width: 280px"></Input>
          </FormItem>
          <FormItem label="密码：" prop="password">
            <Input v-model="formData.password" type="password" placeholder="" style="width: 280px"></Input>
          </FormItem>
          <FormItem label="确认密码：" prop="confirmPassword">
            <Input v-model="formData.confirmPassword" type="password" placeholder="" style="width: 280px"></Input>
          </FormItem>

          <!-- 实名信息 -->
          <div class="section-title">实名信息</div>
          <FormItem label="真实姓名：" prop="name">
            <Input v-model="formData.name" placeholder="" style="width: 280px"></Input>
          </FormItem>
          <FormItem label="联系手机：" prop="phoneNumber">
            <Input v-model="formData.phoneNumber" maxlength="11" placeholder="" style="width: 280px"></Input>
          </FormItem>
          <FormItem label="所属部门：" prop="organizationUnitIds">
            <Cascader v-model="formData.organizationUnitIds" :data="organizationUnitTree" :render-format="renderFormat" filterable change-on-select style="width: 280px" placeholder=""></Cascader>
          </FormItem>

          <!-- 用户协议 -->
          <div class="protocol-section">
            <Checkbox v-model="formData.agreeProtocol">
              <span class="protocol-text">我已阅读并同意</span>
            </Checkbox>
            <a class="protocol-link" @click="showProtocol">《用户注册协议》</a>
          </div>

          <!-- 需要申请开通的模块 -->
          <div class="section-title module-title">需要申请开通的模块(多选)</div>
          <FormItem prop="requestedModules" :label-width="0">
            <div class="module-section">
              <CheckboxGroup v-model="formData.requestedModules">
                <Checkbox v-for="item in moduleList" :key="item.value" :label="item.value" class="module-checkbox">
                  {{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </div>
          </FormItem>

          <!-- 按钮 -->
          <div class="btn-section">
            <Button type="primary" @click="handleSubmit" :loading="submitting" class="submit-btn">提交管理员开通</Button>
            <Button type="primary" ghost @click="goBack" class="back-btn">返回登录</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data() {
    // 确认密码验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.formData.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    // 用户协议验证
    const validateProtocol = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请阅读并同意用户注册协议'))
      } else {
        callback()
      }
    }

    return {
      formData: {
        userName: '',
        password: '',
        confirmPassword: '',
        name: '',
        phoneNumber: '',
        organizationUnitIds: [],
        requestedModules: [],
        agreeProtocol: false,
      },
      organizationUnitTree: [], // 部门树形数据
      moduleList: [], // 模块列表
      submitting: false,
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 50, message: '用户名长度在2-50个字符', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: '用户名只能包含字母和数字',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern:
              /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)(?![a-zA-Z0-9]+$)(?![a-zA-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9\\W_!@#$%^&*`~()-+=]+$)(?![0-9A-Z\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,}$/,
            message: '密码要求长度大于8位，且包含大写字母、小写字母、数字、特殊符号',
            trigger: 'blur',
          },
          { min: 6, max: 20, message: '密码长度在6-20个字符', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' },
        ],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        phoneNumber: [
          { required: true, message: '请输入联系手机', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' },
        ],
        organizationUnitIds: [
          { required: true, type: 'array', min: 1, message: '请选择所属部门', trigger: 'change' },
        ],
        requestedModules: [
          {
            required: true,
            type: 'array',
            min: 1,
            message: '请至少选择一个模块',
            trigger: 'change',
          },
        ],
        agreeProtocol: [{ validator: validateProtocol, trigger: 'change' }],
      },
    }
  },
  mounted() {
    this.getInitData()
  },
  methods: {
    // 获取初始化数据
    async getInitData() {
      try {
        const res = await this.$Ajax.get('/UserRegistration/GetInitData')
        if (res.data.result) {
          // 转换部门树形数据格式为Cascader需要的格式
          this.organizationUnitTree = this.transformTreeData(
            res.data.result.organizationUnitTree || []
          )
          // 模块列表
          this.moduleList = res.data.result.moduleList || []
        }
      } catch (error) {
        console.error('获取初始化数据失败:', error)
      }
    },
    // 转换树形数据格式
    transformTreeData(data) {
      return data.map((item) => ({
        value: item.id,
        label: item.displayName || item.name,
        children:
          item.children && item.children.length > 0
            ? this.transformTreeData(item.children)
            : undefined,
      }))
    },
    // Cascader渲染格式
    renderFormat(labels) {
      return labels.join(' / ')
    },
    // 提交注册
    handleSubmit() {
      // 先检查协议
      if (!this.formData.agreeProtocol) {
        this.$Message.warning('请阅读并同意用户注册协议')
        return
      }

      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            // 获取最后一级部门ID
            const organizationUnitIds =
              this.formData.organizationUnitIds.length > 0
                ? [this.formData.organizationUnitIds[this.formData.organizationUnitIds.length - 1]]
                : []

            const submitData = {
              userName: this.formData.userName,
              password: this.formData.password,
              confirmPassword: this.formData.confirmPassword,
              name: this.formData.name,
              phoneNumber: this.formData.phoneNumber,
              organizationUnitIds: organizationUnitIds,
              requestedModules: this.formData.requestedModules,
            }

            const res = await this.$Ajax.post('/UserRegistration/RegisterUser', submitData)
            if (res.data.result) {
              this.$Modal.success({
                title: '提示',
                content: '注册成功，请等待管理员处理',
                onOk: () => {
                  this.goLogin()
                },
              })
            }
          } catch (error) {
            console.error('注册失败:', error)
          }
          this.submitting = false
        }
      })
    },
    // 显示协议
    showProtocol() {
      window.open(this.$router.resolve({ path: '/protocol' }).href, '_blank')
    },
    // 返回登录
    goLogin() {
      this.$router.push('/')
    },
    // 返回上级
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="less" scoped>
.register-container {
  min-height: 100vh;
  background: #f5f5f5;
}

.header {
  display: flex;
  max-width: 950px;
  align-items: center;
  padding: 10px 20px;
  margin: 0 auto;
  min-height: 100px;
  padding-left: 0px;
  //   background: #fff;
  //   border-bottom: 1px solid #dcdee2;

  .logo-section {
    display: flex;
    align-items: center;

    .logo {
      height: 70px;
      margin-right: 8px;
    }

    .title {
      font-size: 26px;
      font-weight: 600;
      color: #333;
    }
  }
}

.main-content {
  max-width: 950px;
  margin: 0 auto;
  border-top: none;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 72px);
}

.tab-section {
  border-bottom: 1px solid #dcdee2;
  //   background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tab-item {
    padding: 6px 20px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    border-bottom: 3px solid #2d8cf0;
    background: #ffffff;

    &.active {
      color: #e64a4d;
      font-weight: bold;
      border: 1px solid #dcdee2;
      border-bottom: none;
    }
  }

  .login-link {
    padding-right: 20px;
    font-size: 14px;
    color: #666;

    a {
      color: #2d8cf0;
      margin-left: 5px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.form-section {
  flex: 1;
  padding: 15px 40px 30px;
  background: #fff;
  border: 1px solid #dcdee2;
  border-top: none;
}

.section-title {
  font-size: 14px;
  color: #2d8cf0;
  padding: 8px 0;
  margin-bottom: 15px;
  border-bottom: 1px solid #e8eaec;
}

.module-title {
  margin-top: 10px;
  color: #333;
}

.protocol-section {
  padding: 15px 0;
  margin-left: 105px;

  .protocol-text {
    // color: #19be6b;
  }

  .protocol-link {
    color: #2d8cf0;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.module-section {
  padding: 15px 0 15px 40px;

  .module-checkbox {
    margin-right: 25px;
    margin-bottom: 12px;
  }
}

.btn-section {
  margin-top: 30px;
  padding: 20px 0;
  border-top: 1px solid #e8eaec;
  text-align: center;

  .submit-btn {
    min-width: 130px;
    margin-right: 15px;
  }

  .back-btn {
    min-width: 100px;
  }
}

// 调整表单项样式
/deep/ .ivu-form-item {
  margin-bottom: 18px;
}

/deep/ .ivu-form-item-label {
  color: #515a6e;
}

/deep/ .ivu-form-item-required .ivu-form-item-label:before {
  color: #ed4014;
}
</style>
